import React, { createContext, useContext, type ReactNode, type PropsWithChildren } from 'react';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import type { EventHandlers } from '../../common/types.tsx';

const EventHandlersContext = createContext<EventHandlers | null>(null);

const EventHandlersProvider = ({
	children,
	eventHandlers,
}: {
	children: ReactNode;
	eventHandlers: EventHandlers;
}) => {
	return (
		<EventHandlersContext.Provider value={eventHandlers}>{children}</EventHandlersContext.Provider>
	);
};

export const useEventHandlers = (): EventHandlers => {
	const context = useContext(EventHandlersContext);
	if (context === null) {
		return {};
	}
	return context;
};

export const MaybeEventHandlersProvider = componentWithCondition(
	() => fg('timeline_rollups_issue_table_callbacks'),
	EventHandlersProvider,
	({ children }: PropsWithChildren<{ eventHandlers: EventHandlers }>) => children,
);
